import React from 'react';

var Spacer = function (_a) {
    var _b = _a.when, when = _b === void 0 ? true : _b, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, children = _a.children;
    var style = {};
    if (!when) {
        return React.createElement(React.Fragment, null, children);
    }
    if (top) {
        style.marginTop = "".concat(top, "px");
    }
    if (right) {
        style.marginRight = "".concat(right, "px");
    }
    if (bottom) {
        style.marginBottom = "".concat(bottom, "px");
    }
    if (left) {
        style.marginLeft = "".concat(left, "px");
    }
    return React.createElement("div", { style: style }, children);
};

export { Spacer as default };
//# sourceMappingURL=Spacer.js.map
